import React from 'react';
import { Button } from './ui/Button';
import { Sparkles } from 'lucide-react';
export function CallToAction() {
  const scrollToOffers = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const offersSection = document.getElementById('comprar');
    if (offersSection) {
      const headerHeight = 56;
      const isMobile = window.innerWidth < 768;
      const offset = isMobile ? -10 : 50;
      const elementPosition = offersSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 bg-gradient-to-br from-pink-600 via-pink-700 to-gray-900 relative overflow-hidden" data-id="element-25">
      <div className="container mx-auto px-4 text-center relative z-10" data-id="element-26">
        <div className="inline-block p-3 rounded-full bg-white/10 backdrop-blur-sm mb-8 animate-bounce" data-id="element-27">
          <Sparkles className="w-8 h-8 text-white" data-id="element-28" />
        </div>

        <h2 className="text-4xl md:text-6xl font-serif font-bold text-white mb-6" data-id="element-29">
          Transformá tus clases con el <br data-id="element-30" />
          <span className="text-gray-900" data-id="element-31">MegaPack Danza Lista</span>
        </h2>

        <p className="text-xl text-white max-w-2xl mx-auto mb-10" data-id="element-32">
          Accedé hoy mismo a los 6 tomos, 3 bonos exclusivos y planificaciones
          listas para usar. Empezá a disfrutar más de tu tiempo libre.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-33">
          <a href="#comprar" onClick={scrollToOffers} data-id="element-34">
            <Button size="lg" className="text-xl px-10 py-6 bg-gray-900 text-white hover:bg-black shadow-2xl hover:scale-105 transform transition-all font-bold border-0" data-id="element-35">
              ¡Quiero el MegaPack Ahora!
            </Button>
          </a>
        </div>

        <p className="mt-6 text-sm text-white/90" data-id="element-36">
          Acceso inmediato • Pago seguro • Garantía 7 días
        </p>
      </div>
    </section>;
}